import { render, staticRenderFns } from "./difference.vue?vue&type=template&id=98e52290&scoped=true&"
import script from "./difference.vue?vue&type=script&lang=js&"
export * from "./difference.vue?vue&type=script&lang=js&"
import style0 from "./difference.vue?vue&type=style&index=0&id=98e52290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e52290",
  null
  
)

export default component.exports